import React from 'react';
import PropTypes from 'prop-types';
import RelinkUpdateBlock from './RelinkUpdateBlock';

FirmwareUpdate.propTypes = {
    permissions: PropTypes.string,
    station: PropTypes.object,
    canAccessFirmware: PropTypes.func,
    getFirmwareVersion: PropTypes.func,
    loadFirmwareFiles: PropTypes.func,
    updateFirmware: PropTypes.func,
};

export default function FirmwareUpdate({
    canAccessFirmware,
    getFirmwareVersion,
    loadFirmwareFiles,
    updateFirmware,
    ...props
}) {
    return (
        <RelinkUpdateBlock
            {...props}
            canAccess={canAccessFirmware}
            getVersion={getFirmwareVersion}
            loadFiles={loadFirmwareFiles}
            updateVersion={updateFirmware}
            title="Обновление прошивки (OTA)"
            idPrefix="firmware"
            versionField="firmware_version"
            versionUpdatedField="firmware_version_updated"
            fileLabel="Файл прошивки"
            fileMetaField="fileName"
        />
    );
}
